import React from "react";
import ServiceSpaHero from "../sections/ServiceSpaHero";
import AboutServices from "../sections/AboutServices";
import ServicesDoctors from "../sections/ServicesDoctors";
import Contact from "../sections/Contact";

const ServiceSPA = () => {
  return (
    <div>
      <ServiceSpaHero />
      <AboutServices />
      <ServicesDoctors />
      <Contact />
    </div>
  );
};

export default ServiceSPA;
